module.exports = __webpack_public_path__ + "static/shark.98467332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/libraries/shark.jpg
// module id = 60
// module chunks = 82267189633957 159792248505240 248600712657012